import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },

    // 1.#2e4442
    //2. #4a706d
    // 3. #9c9f84
    // 4. #c5c6a9

    themes: {
      light: {
        primary: "#C8D0C9",
        secondary: "#686739",
        accent: "#c5c6a9",
        brick: "#a24c31",
        error: "#FF5252",
        info: "#2196F3",
        success: "#8bc541",
        warning: "#FFC107",
        grey: "#e7e7e7",
        darkgrey: "#808080",
        lightgray: "#AEAEAE",
      },
    },
  },
});
